import * as React from "react"
import { Dispatch } from "redux"
// @ts-expect-error: Flow to TS migration.
import { connect, Connector } from "react-redux"
import styled from "styled-components" // eslint-disable-line no-restricted-imports
import MagicLoginRenderer from "@kiwicom/nitro/lib/components/MagicLogin/Renderer"
import NitroMagicLogin from "@kiwicom/nitro/lib/components/MagicLogin"
import { AuthToken } from "@kiwicom/nitro/lib/records/Auth"

import { setCustomerVerified } from "../../services/options/actions"
import { handleSimpleToken } from "../SmartFAQ/services/SmartFAQDuck"
import useRequiredLoginModal from "./hooks/useRequiredLoginModal"
import useIntroLoginModal from "./hooks/useIntroLoginModal"
import { useIsLoggedIn } from "@kiwicom/nitro/lib/services/auth/context"
import { useAuth } from "@kiwicom/nitro/lib/services/auth/context"

type Props = {
  onGetSimpleToken: (arg1: AuthToken) => void
}

const LoginWrapper = styled.div`
  z-index: 10001;
  position: relative;
`

const MagicLogin = ({ onGetSimpleToken }: Props) => {
  const { isRequiredModalVisible, onCloseRequiredModal } = useRequiredLoginModal()
  const { isIntroModalVisible, onCloseIntroModal } = useIntroLoginModal()
  const { isSkyUsersV2 } = useAuth()
  const isLoggedIn = useIsLoggedIn()

  if (isLoggedIn) {
    return null
  }

  if (isIntroModalVisible) {
    return (
      /* @ts-expect-error: Flow to TS migration. */
      <NitroMagicLogin
        isSkyUsersV2={isSkyUsersV2}
        onClose={onCloseIntroModal}
        type="mmb"
        onGetSimpleToken={onGetSimpleToken}
      />
    )
  }

  if (isRequiredModalVisible)
    return (
      <LoginWrapper>
        {/* @ts-expect-error: Flow to TS migration. */}
        <NitroMagicLogin
          isSkyUsersV2={isSkyUsersV2}
          type="mmb"
          initialScreen="requiredLogin"
          onClose={onCloseRequiredModal}
          onGetSimpleToken={onGetSimpleToken}
          onContinueAsGuest={onCloseRequiredModal}
        />
      </LoginWrapper>
    )

  return (
    <LoginWrapper>
      <MagicLoginRenderer isSkyUsersV2={isSkyUsersV2} onGetSimpleToken={onGetSimpleToken} />
    </LoginWrapper>
  )
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const connector: Connector<Record<any, any>, Props> = connect(null, (dispatch: Dispatch<any>) => ({
  onGetSimpleToken: (response: AuthToken) => {
    dispatch(setCustomerVerified(true))
    dispatch(handleSimpleToken(response))
  },
}))

export default connector(MagicLogin)
